import { ref as E, computed as s, createElementBlock as B, openBlock as R, normalizeStyle as g, normalizeClass as c, createElementVNode as m, unref as n } from "vue";
import { SCREEN_BREAKPOINT_MEDIUM as x, SCREEN_BREAKPOINT_LARGE as h } from "../../foundation/tokens/exported-variables.js";
import S from "../../utils/validators/aspect-ratio.js";
import _ from "../../utils/validators/image.js";
import { screenProp as j } from "../../utils/utilsScreen.js";
/* empty css                   */
const z = ["media", "srcset", "width", "height"], C = ["media", "srcset", "width", "height"], P = ["media", "srcset", "width", "height"], I = ["loading", "src", "alt"], D = /* @__PURE__ */ Object.assign({
  name: "DsImageElement"
}, {
  __name: "image-element",
  props: {
    ...j,
    /**
     * Image
     * @property {Object} image.small - { src: String, name: String, dimensions: Object, aspectRatio: String }
     * @property {Object} image.medium - { src: String, name: String, dimensions: Object, aspectRatio: String }
     * @property {Object} image.large -  { src: String, name: String, dimensions: Object, aspectRatio: String }
     */
    image: {
      type: Object,
      required: !0,
      validator: (t) => _(t)
    },
    /**
     * Image aspect ratio, sets aspect ratio for image. Defaults to a square image.
     */
    aspectRatio: {
      type: String,
      default: null,
      validator: (t) => S(t)
    },
    /**
     * Image loading strategy
     */
    lazy: {
      type: Boolean,
      default: !1
    },
    /**
     * Image with Shadow
     */
    withShadow: {
      type: Boolean,
      default: !1
    },
    withPadding: {
      type: Boolean,
      default: !1
    },
    /*
     * Use this prop to have default grey placeholder on image
     * But if the usecase requires other changes, use emitted event 'image-load-failed'
     */
    showPlaceholderOnError: {
      type: Boolean,
      default: !1
    },
    /*
     * Use this prop to control if the background color is displayed on the image (if present)
     * In most cases we want to display it, so default is true
     */
    showBackgroundColor: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["image-load-failed"],
  setup(t, { emit: v }) {
    const d = E(""), e = t, f = v, o = s(() => {
      var a, i;
      return ((i = (a = e.image) == null ? void 0 : a.original) == null ? void 0 : i.extension) === "svg";
    }), r = s(() => {
      var a;
      return e.aspectRatio || ((a = e.image[e.screen]) == null ? void 0 : a.aspectRatio);
    }), u = s(() => {
      var a, i;
      return ((a = e.image[e.screen]) == null ? void 0 : a.color) || ((i = e.image.original) == null ? void 0 : i.color);
    }), w = s(() => {
      let a = "";
      return u.value && e.showBackgroundColor && (a += `background: ${u.value};`), r.value && o.value && (a += `aspect-ratio: ${r.value};`), a;
    }), p = s(() => e.lazy || e.image.lazy), l = s(() => e.image.small.dimensions ? {
      small: e.image.small.dimensions,
      medium: e.image.medium.dimensions,
      large: e.image.large.dimensions
    } : {
      small: {
        width: null,
        height: null
      },
      medium: {
        width: null,
        height: null
      },
      large: {
        width: null,
        height: null
      }
    }), y = (a) => {
      f("image-load-failed", a), e.showPlaceholderOnError && (d.value = "ds-image-element--error");
    };
    return (a, i) => (R(), B("picture", {
      class: c(["ds-image-element", [
        d.value,
        {
          "ds-shadow": t.withShadow,
          "ds-image-element--center": o.value
        }
      ]]),
      style: g(w.value),
      "data-j-picture": ""
    }, [
      m("source", {
        media: `(max-width: ${n(x) - 1}px)`,
        srcset: t.image.small.src,
        width: l.value.small.width,
        height: l.value.small.height,
        "data-j-source-small": ""
      }, null, 8, z),
      m("source", {
        media: `(max-width: ${n(h) - 1}px)`,
        srcset: t.image.medium.src,
        width: l.value.medium.width,
        height: l.value.medium.height,
        "data-j-source-medium": ""
      }, null, 8, C),
      m("source", {
        media: `(min-width: ${n(h)}px)`,
        srcset: t.image.large.src,
        width: l.value.large.width,
        height: l.value.large.height,
        "data-j-source-large": ""
      }, null, 8, P),
      m("img", {
        loading: p.value ? "lazy" : "eager",
        src: t.image.small.src,
        alt: t.image.small.name,
        class: c({
          "ds-padding-y-48 ds-padding-x-48": t.withPadding,
          "ds-image-element__svg": o.value,
          "ds-image-element__image": !o.value
        }),
        style: g(!o.value && r.value ? { aspectRatio: r.value } : null),
        "data-j-image": "",
        onError: y
      }, null, 46, I)
    ], 6));
  }
});
export {
  D as default
};
